/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateTaxDeclarationCommand } from '../../models/update-tax-declaration-command';

export interface ApiTaxDeclarationInitializeSalesforceUpdatePost$Json$Params {
      body: UpdateTaxDeclarationCommand
}

export function apiTaxDeclarationInitializeSalesforceUpdatePost$Json(http: HttpClient, rootUrl: string, params: ApiTaxDeclarationInitializeSalesforceUpdatePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiTaxDeclarationInitializeSalesforceUpdatePost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiTaxDeclarationInitializeSalesforceUpdatePost$Json.PATH = '/api/TaxDeclaration/initialize-salesforce-update';
